import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Star, ChevronRight, ChevronLeft, Check } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

// Import client logos
import JSWLogo from '../assets/Images/logos/JSW.png';
import MSPLLogo from '../assets/Images/logos/MSPL.png';
import VESCOLogo from '../assets/Images/logos/VESCO.jpg';
import BMMLogo from '../assets/Images/logos/BMM.webp';
import DRNLogo from '../assets/Images/logos/DRN.png';
import HospetSteelsLogo from '../assets/Images/logos/HOSPET_STEELS.jpg';
import KalayniLogo from '../assets/Images/logos/KALAYNI.png';
import KirloskarLogo from '../assets/Images/logos/KIRLOSKAR.png';
import MineraLogo from '../assets/Images/logos/MINERA.webp';
import MukundLogo from '../assets/Images/logos/MUKUND.png';
import SLRLogo from '../assets/Images/logos/SLR.jpg';
import UltratechLogo from '../assets/Images/logos/ULTRATECH.png';
import AmruthaLogo from '../assets/Images/logos/amrutha.png';
import BysymLogo from '../assets/Images/logos/bysym.jpg';
import CSB from '../assets/Images/logos/CSB.png';
import CreativeEngLogo from '../assets/Images/logos/creativeEng.jpeg';
import KalpataruLogo from '../assets/Images/logos/kalpataru.jpg';
import MeilLogo from '../assets/Images/logos/meil.png';
import MukundSumiLogo from '../assets/Images/logos/mukandsumi.png';
import RockTechLogo from '../assets/Images/logos/rockTech.jpeg';
import UniversalLogo from '../assets/Images/logos/universal.webp';
import FomentoMiningLogo from '../assets/Images/logos/fomento.jpeg';

const Testimonials = () => {
  const navigate = useNavigate();
  const testimonialsRef = useRef([]);
  const [currentSlide, setCurrentSlide] = React.useState(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fade-up');
          }
        });
      },
      { threshold: 0.1 }
    );

    testimonialsRef.current.forEach((card) => {
      if (card) observer.observe(card);
    });

    return () => observer.disconnect();
  }, []);

  const testimonials = [
    // {
    //   name: 'JSW',
    //   logo: JSWLogo,
    //   content: 'The hydraulic cylinder refurbishment was exceptional. Our excavator cylinders now perform like new, with zero leaks and smoother operation than before.',
    //   rating: 5
    // },
    {
      name: 'MSPL',
      logo: MSPLLogo,
      content: 'Their hydraulic pump reconditioning service saved us thousands in replacement costs. The detailed test report showed significant improvement in flow rates and pressure.',
      rating: 5
    },
    {
      name: 'VESCO',
      logo: VESCOLogo,
      content: 'The on-site hydraulic service team averted a potential shutdown. Their quick diagnosis and repair of our main hydraulic circuit was impressive.',
      rating: 5
    },
    // {
    //   name: 'ULTRATECH',
    //   logo: UltratechLogo,
    //   content: 'The precision machining of our custom hydraulic manifold was flawless. The team delivered ahead of schedule with excellent communication throughout.',
    //   rating: 5
    // },
    {
      name: 'DRN',
      logo: DRNLogo,
      content: 'The rock breaker refurbishment extended our equipment life by 2+ years. The thorough testing and calibration made all the difference in performance.',
      rating: 5
    },
    {
      name: 'HOSPET STEELS',
      logo: HospetSteelsLogo,
      content: 'Their hydraulic circuit block repair resolved our persistent pressure issues. The detailed test report helped us understand the root cause.',
      rating: 5
    },
    {
      name: 'MINERA',
      logo: MineraLogo,
      content: 'Reliable partner for all hydraulic maintenance needs. Their service has been crucial to our operations.',
      rating: 4
    },
    {
      name: 'KALAYNI',
      logo: KalayniLogo,
      content: 'The hydraulic motor refurbishment was completed with excellent workmanship. The motor has been running smoothly for over 6 months with no issues.',
      rating: 5
    },
    {
      name: 'KIRLOSKAR',
      logo: KirloskarLogo,
      content: 'Their test bench diagnostics caught a failing pump before it caused downtime. The preventive maintenance program has been invaluable for our operations.',
      rating: 5
    },
    {
      name: 'FEMENTHO',
      displayName: 'FEM',
      logo: FomentoMiningLogo,
      content: 'The hydraulic valve refurbishment restored precise control to our system. Their attention to detail in cleaning and calibration was impressive.',
      rating: 5
    },
    {
      name: 'MUKUND',
      logo: MukundLogo,
      content: 'Professional service with attention to detail. Their team is always our first choice for hydraulic solutions.',
      rating: 5
    },
    {
      name: 'SLR',
      logo: SLRLogo,
      content: 'Exceptional hydraulic repair services. Their quick response time has been crucial for our production line.',
      rating: 5
    },
    {
      name: 'ULTRATECH',
      logo: UltratechLogo,
      content: 'Consistently reliable service. Their expertise in hydraulic systems is unmatched in the industry.',
      rating: 5
    },
    {
      name: 'SRI SRINIVASA MINERALS',
      displayName: 'SSM',
      logo: null,
      content: 'Their 24/7 emergency service saved us from a week of downtime. The team arrived on-site with all necessary parts and tools to fix our hydraulic system.',
      rating: 5
    },
    {
      name: 'INFRASTRUCTURE LOGISTIC PVT LTD',
      displayName: 'ILPL',
      logo: null,
      content: 'The hydraulic gearbox repair was completed with exceptional quality. The unit has been performing beyond our expectations since the service.',
      rating: 5
    },


    {
      name: 'TERAPANTH FOODS LTD ',
      logo: null,
      content: 'Great technical support and service. Their team is always ready to assist with our hydraulic needs.',
      rating: 4
    },



  ];

  const clients = [
    {
      id: 1,
      name: 'JSW',
      logo: JSWLogo
    },
    {
      id: 2,
      name: 'MSPL',
      logo: MSPLLogo
    },
    {
      id: 3,
      name: 'VESCO',
      logo: VESCOLogo
    },
    {
      id: 4,
      name: 'BMM',
      logo: BMMLogo
    },
    {
      id: 5,
      name: 'DRN',
      logo: DRNLogo
    },
    {
      id: 6,
      name: 'HOSPET STEELS',
      logo: HospetSteelsLogo
    },
    {
      id: 7,
      name: 'SLR',
      logo: SLRLogo
    },
    {
      id: 8,
      name: 'MUKUND',
      logo: MukundLogo
    },
    {
      id: 9,
      name: 'KALAYNI',
      logo: KalayniLogo
    },
    {
      id: 10,
      name: 'KIRLOSKAR',
      logo: KirloskarLogo
    },
    {
      id: 11,
      name: 'ULTRATECH',
      logo: UltratechLogo
    },
    {
      id: 12,
      name: 'MINERA',
      logo: MineraLogo
    },



    // Clients with new logos
    {
      id: 13,
      name: 'AMRUTHA',
      logo: AmruthaLogo
    },
    {
      id: 14,
      name: 'BYSYM',
      logo: BysymLogo
    },
    {
      id: 15,
      name: 'CREATIVE ENGINEERS',
      logo: CreativeEngLogo
    },
    {
      id: 16,
      name: 'KALPATARU',
      logo: KalpataruLogo
    },
    {
      id: 17,
      name: 'MEIL',
      logo: MeilLogo
    },
    {
      id: 18,
      name: 'MUKAND SUMI',
      logo: MukundSumiLogo
    },
    {
      id: 19,
      name: 'ROCK TECH',
      logo: RockTechLogo
    },
    {
      id: 20,
      name: 'UNIVERSAL',
      logo: UniversalLogo
    },
    {
      id: 21,
      name: 'CSB',
      logo: CSB
    },
    // Clients without logos (kept for reference)
    {
      id: 22,
      name: 'Fomento Mining',
      logo: FomentoMiningLogo
    },
    {
      id: 23,
      name: 'SRI SRINIVASA MINERALS',
      logo: null,
      isPlaceholder: true
    },
    {
      id: 24,
      name: 'INFRASTRUCTURE LOGISTIC PVT LTD',
      logo: null,
      isPlaceholder: true
    },
    {
      id: 25,
      name: 'TERAPANTH FOODS LTD',
      logo: null,
      isPlaceholder: true
    },
    {
      id: 26,
      name: 'AMITH EARTH MOVERS',
      logo: null,
      isPlaceholder: true
    },
    {
      id: 27,
      name: 'ILC IRON AND STEEL',
      logo: null,
      isPlaceholder: true
    },
    {
      id: 28,
      name: 'BKG M SAND AND AGGREGATES PVT LTD',
      logo: null,
      isPlaceholder: true
    },
    {
      id: 29,
      name: 'SKMPL MINING PVT LTD',
      logo: null,
      isPlaceholder: true
    },
    {
      id: 30,
      name: 'HOSMANI GRANITES',
      logo: null,
      isPlaceholder: true
    },
    {
      id: 31,
      name: 'OSE Hunugund Hospet Highway Pvt Ltd',
      logo: null,
      isPlaceholder: true
    }
  ];



  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const renderStars = (rating) => {
    return Array(5).fill(0).map((_, i) => (
      <Star
        key={i}
        className={`w-5 h-5 ${i < rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`}
      />
    ));
  };

  return (
    <div className="min-h-screen flex flex-col pt-20 md:pt-24">
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-900 to-blue-700 text-white py-16 md:py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-3 sm:mb-4">Our Valued Clients</h1>
          <p className="text-lg sm:text-xl text-blue-100 max-w-3xl mx-auto px-4">
            Trusted by industry leaders across India for our exceptional hydraulic solutions and services.
          </p>
        </div>
      </section>

      {/* Clients Logo Section */}
      <section className="py-12 md:py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl font-bold text-[#00325b] mb-3 sm:mb-4">Our Esteemed Clients</h2>
            <div className="w-16 sm:w-20 h-1 bg-blue-600 mx-auto mb-6 sm:mb-8"></div>
            <p className="text-gray-600 text-sm sm:text-base max-w-3xl mx-auto mb-8 sm:mb-12 px-4">
              We are proud to have served some of the most respected names in the industry, building long-term partnerships based on trust and exceptional service.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-6 md:gap-8 items-center justify-items-center">
            {clients.map((client, index) => (
              <div
                key={index}
                className={`flex flex-col items-center p-4 rounded-lg hover:shadow-lg transition-shadow duration-300 w-full ${client.logo ? 'min-h-[120px]' : 'min-h-[80px] justify-center'
                  }`}
              >
                {client.logo ? (
                  <div className="h-16 sm:h-20 w-32 sm:w-40 mb-2 sm:mb-3 flex items-center justify-center bg-white p-1 sm:p-2 rounded">
                    <img
                      src={client.logo}
                      alt={client.name}
                      className="max-h-full max-w-full object-contain"
                      loading="lazy"
                    />
                  </div>
                ) : (
                  <span className="text-sm sm:text-base font-semibold text-center text-[#002B5B]">
                    {client.name}
                  </span>
                )}

              </div>
            ))}
          </div>

          {/* <div className="mt-16 grid md:grid-cols-3 gap-8">
            <div className="bg-blue-50 p-6 rounded-xl">
              <div className="flex items-center mb-3">
                <div className="bg-blue-100 p-2 rounded-full mr-3">
                  <Check className="w-6 h-6 text-blue-600" />
                </div>
                <h3 className="text-lg font-semibold text-[#00325b]">50+</h3>
              </div>
              <p className="text-gray-600">Satisfied Enterprise Clients</p>
            </div>
            
            <div className="bg-blue-50 p-6 rounded-xl">
              <div className="flex items-center mb-3">
                <div className="bg-blue-100 p-2 rounded-full mr-3">
                  <Check className="w-6 h-6 text-blue-600" />
                </div>
                <h3 className="text-lg font-semibold text-[#00325b]">95%</h3>
              </div>
              <p className="text-gray-600">Client Retention Rate</p>
            </div>
            
            <div className="bg-blue-50 p-6 rounded-xl">
              <div className="flex items-center mb-3">
                <div className="bg-blue-100 p-2 rounded-full mr-3">
                  <Check className="w-6 h-6 text-blue-600" />
                </div>
                <h3 className="text-lg font-semibold text-[#00325b]">24/7</h3>
              </div>
              <p className="text-gray-600">Support Availability</p>
            </div>
          </div> */}
        </div>
      </section>

      {/* Testimonials Section */}
      {/* <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-[#00325b] mb-4 font-['Poppins']">What Our Clients Say</h2>
            <div className="w-20 h-1 bg-blue-600 mx-auto mb-8"></div>
            <p className="text-gray-600 max-w-3xl mx-auto font-['Poppins']">Hear from our valued clients about their experience working with us</p>
          </div>
          
          <div className="relative">
            <div className="overflow-hidden">
              <div 
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${currentSlide * 25}%)` }}
              >
                {testimonials.map((testimonial, index) => (
                  <div 
                    key={index} 
                    className="w-full md:w-1/2 lg:w-1/4 px-4 flex-shrink-0"
                  >
                    <div className="bg-gray-50 rounded-xl p-6 h-full hover:shadow-lg transition-shadow duration-300 border border-gray-100 flex flex-col items-center font-['Poppins']">
                      {testimonial.logo ? (
                        <div className="w-20 h-20 rounded-full bg-white p-1 border-2 border-blue-100 mb-4 flex items-center justify-center overflow-hidden">
                          <img 
                            src={testimonial.logo} 
                            alt={testimonial.name} 
                            className="w-full h-full object-contain p-1"
                          />
                        </div>
                      ) : (
                        <div className="w-20 h-20 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center text-2xl font-bold mb-4 font-['Poppins']">
                          {testimonial.displayName || testimonial.name.split(' ').map(word => word[0]).join('').substring(0, 2).toUpperCase()}
                        </div>
                      )}
                      <div className="flex justify-center mb-4">
                        {renderStars(testimonial.rating)}
                      </div>
                      <p className="text-gray-700 italic mb-6 text-center leading-relaxed text-[15px] font-light">"{testimonial.content}"</p>
                      
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            <button 
              onClick={prevSlide}
              className="absolute left-0 top-1/2 -translate-y-1/2 -ml-4 bg-white p-2 rounded-full shadow-md text-blue-600 hover:bg-blue-50 transition-colors z-10"
              aria-label="Previous testimonials"
            >
              <ChevronLeft className="w-6 h-6" />
            </button>
            <button 
              onClick={nextSlide}
              className="absolute right-0 top-1/2 -translate-y-1/2 -mr-4 bg-white p-2 rounded-full shadow-md text-blue-600 hover:bg-blue-50 transition-colors z-10"
              aria-label="Next testimonials"
            >
              <ChevronRight className="w-6 h-6" />
            </button>
          </div>
        </div>
      </section> */}



      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-blue-900 to-blue-700 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Ready to Start Your Success Story?</h2>
          <p className="text-xl text-blue-100 mb-8 max-w-3xl mx-auto">
            Let's discuss how we can help you overcome your hydraulic challenges and achieve operational excellence.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <button
              onClick={() => navigate('/contact')}
              className="bg-white text-blue-900 hover:bg-blue-50 font-semibold py-3 px-8 rounded-lg transition-colors duration-300"
            >
              Get in Touch
            </button>
            <button
              onClick={() => navigate('/services')}
              className="bg-transparent border-2 border-white text-white hover:bg-white/10 font-semibold py-3 px-8 rounded-lg transition-colors duration-300"
            >
              Explore Our Services
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Testimonials;